import React from "react";
import * as Icons from "lucide-react";

// Renders a lucide icon by string name
export const Icon = ({ name, className }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} />;
};

export const SectionHeading = ({ eyebrow, title, subtitle, center }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-blue-700 mb-3">
        {eyebrow}
      </span>
    )}
    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">{title}</h2>
    {subtitle && <p className="mt-4 text-lg text-slate-600">{subtitle}</p>}
  </div>
);
